import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import strip from "striptags";

export default function CommunityCC() {  
   
    let app = ApplicantContainer.useContainer();

    let communityCC = app.inStdValues.frCommunityCareInfo;

    function handleChange(evt) {
  
       if(" frCCMobile frCCTel".search( evt.target.id) > 0) 
         evt.target.value = evt.target.value.replace(/\D/g, '');
    
      evt.target.value = strip(evt.target.value);
      const values = communityCC;
      values[evt.target.id] =  evt.target.value;

      app.onChangeInStdValues({...app.inStdValues, frCommunityCareInfo: values}); 
    }

    return (    
    <>
        <Form.Row>
        <Col xs={12}>            
            <Form.Group as={Col} controlId="frCC">
            <Form.Label className="h6">Residential Home/Community Care Centre Information</Form.Label>
            </Form.Group>
        </Col>  
        </Form.Row>

        <Form.Row>
        <Col xs={12} sm={2}>
        <Form.Group as={Col} controlId="frCCHome">
            <Form.Label>Name of home/centre</Form.Label>                    
         </Form.Group>   
         </Col>    
         <Col xs={12} sm={10}>
         <Form.Group as={Col} controlId="frCCHome">
        
            <Form.Control type="text" placeholder="" onChange={handleChange} value={communityCC.frCCHome} />
            
        </Form.Group>
        </Col>
        </Form.Row>
        <Form.Row>
        <Col xs={12} sm={2}>
            <Form.Group as={Col} controlId="frCCAddr">
            <Form.Label>Address</Form.Label>
            </Form.Group>
        </Col>        
        <Col xs={12} sm={10}>            
            <Form.Group as={Col} controlId="frCCAddr" >            
            <Form.Control as="textarea" rows={3} name="frCCParentWorkAddrOne" onChange={handleChange} value={communityCC.frCCAddr} />     
            </Form.Group>
        </Col>
        </Form.Row>
       
        <Form.Row className="flex">
            <Col xs={12} sm={6}>
                <Form.Group as={Col} controlId="frCCLeaderName">
                <Form.Label>Name of coordinator / chairperson / supervisor / leader</Form.Label>
                <Form.Control type="input" onChange={handleChange} value={communityCC.frCCLeaderName}/>
            </Form.Group>
            </Col>
            
            <Col xs={12} sm={6}>
                <Form.Group as={Col} controlId="frCCPosition">
                <Form.Label>Position/title</Form.Label>
                <Form.Control type="input" onChange={handleChange} value={communityCC.frCCPosition} />
            </Form.Group>
            </Col>            
        </Form.Row>

        <Form.Row className="flex">
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCTel">
                <Form.Label>Telephone no. (home/centre)</Form.Label>
                <Form.Control type="input" onChange={handleChange} value={communityCC.frCCTel} />
            </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCMobile">
                <Form.Label>H/P</Form.Label>
                <Form.Control type="input" onChange={handleChange} value={communityCC.frCCMobile}/>
            </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frCCEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="input" onChange={handleChange} value={communityCC.frCCEmail}/>
            </Form.Group>
            </Col>           
        </Form.Row>

          
    </>
    );
}